import { useEffect, useState } from 'react';

// ui-kit/Modal and ui-kit/Drawer both toggle this class on <body> while they are open
// (Modal/index.js componentDidUpdate, Drawer/index.js), and base.scss hangs the scroll lock
// off it. It is the one signal that says "a blocking overlay is on screen" without every
// caller having to know which component put it there.
const MODAL_OPEN_CLASS = 'modal-open';

const readIsOpen = () => typeof document !== 'undefined' && document.body.classList.contains(MODAL_OPEN_CLASS);

/**
 * True while a ui-kit Modal or Drawer is open.
 *
 * Toasts render at a higher z-index than the modal layer (the toast container is at 100000,
 * ui-kit/Modal at 9000), so anything long-lived in a toast will paint over a dialog and can
 * cover its buttons. Components that own a persistent toast use this to stand down while a
 * dialog has the user's attention.
 */
const useBodyModalOpen = () => {
  const [isModalOpen, setIsModalOpen] = useState(readIsOpen);

  useEffect(() => {
    const sync = () => setIsModalOpen(readIsOpen());
    const observer = new MutationObserver(sync);
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    // The class may have been toggled between the initial render and this effect.
    sync();
    return () => observer.disconnect();
  }, []);

  return isModalOpen;
};

export default useBodyModalOpen;
